import type { BlockDefinition, DividerProps } from '../types';

export const divider: BlockDefinition<DividerProps> = {
  type: 'divider',
  meta: {
    label: 'Divider',
    icon: '—',
    category: 'layout',
    description: 'A thin horizontal line for separating sections.',
  },
  defaults: () => ({
    thickness: 1,
    spacing: 8,
  }),
  validate(input) {
    const i = (input ?? {}) as Partial<DividerProps>;
    return {
      thickness: typeof i.thickness === 'number' ? Math.max(0, Math.min(4, i.thickness)) : 1,
      spacing: typeof i.spacing === 'number' ? Math.max(0, Math.min(64, i.spacing)) : 8,
    };
  },
  render(props) {
    return `<div class="pb-block pb-divider" style="margin:${props.spacing}px 0;">
  <div style="height:${props.thickness}px;background:rgba(0,0,0,0.12);"></div>
</div>`;
  },
};
